import { Controller } from 'stimulus';

export default class extends Controller {
  static targets = ['element'];

  globalHide(event) {
    if (this.element.contains(event.target) === false && !this.elementTarget.classList.contains('hidden')) {
      this.elementTarget.classList.add('hidden');
      this.elementTarget.classList.add('none');
    }
  }

  hide() {
    this.elementTarget.classList.add('hidden');
    this.elementTarget.classList.add('none');
  }

  hideAll() {
    this.elementTargets.forEach((el) => {
      el.classList.add('hidden');
      el.classList.add('none');
    });
  }

  show() {
    this.elementTarget.classList.remove('hidden');
    this.elementTarget.classList.remove('none');
  }

  showAll() {
    this.elementTargets.forEach((el) => {
      el.classList.remove('hidden');
      el.classList.remove('none');
    });
  }

  toggle() {
    this.elementTarget.classList.toggle('hidden');
    this.elementTarget.classList.toggle('none');
  }

  toggleAll() {
    this.elementTargets.forEach((el) => {
      el.classList.toggle('hidden');
      el.classList.toggle('none');
    });
  }
}
